import { useQuery, useQueryContext } from '@contexts/index'
import React, { useEffect, useRef, useState } from 'react'

import SearchBar from './SearchBar'
import SearchResults from './SearchResults'

const DealerFinder = ({ setDealer, noPadding = false }) => {
  const [searchData, setSearchData] = useState([])
  const query = useQuery()
  const { setQuery } = useQueryContext()
  const [activeGroup, setActiveGroup] = useState(null)
  const searchBarRef = useRef(null)

  useEffect(() => {
    if (query?.group) {
      setActiveGroup({
        uuid: query.group,
        name: query.groupName || 'Loading...',
      })
    } else {
      setActiveGroup(null)
    }
  }, [query?.group, query?.groupName])

  const updateSearchData = (data) => {
    setSearchData(data)
  }

  const handleRemoveGroup = () => {
    setQuery((prevQuery) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars
      const { group, groupName, ...rest } = prevQuery
      return rest
    })

    setTimeout(() => {
      if (searchBarRef.current?.triggerSearch) {
        searchBarRef.current.triggerSearch()
      }
    }, 100)
  }

  return (
    <div className={`dealer-finder ${noPadding ? '' : 'container'}`}>
      <SearchBar ref={searchBarRef} onSearchDataUpdate={updateSearchData} />
      <SearchResults
        searchData={searchData}
        setDealer={setDealer}
        activeGroup={activeGroup}
        onRemoveGroup={handleRemoveGroup}
      />
    </div>
  )
}

export default DealerFinder
